import { CustomLoader } from "@/components/Loader";
import { CreateStore } from "@a4b/api/src/modules/Monetisation/Puja/types";
import { Button, Input, Row, Spin, TableProps, Tooltip } from "antd";
import { TablePaginationConfig } from "antd/es/table";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CopyOutlined } from '@ant-design/icons'


const useTableConfig = (
    storeList: CreateStore[],
    isLoading: boolean,
    setShowPujaUpdateDrawer: React.Dispatch<React.SetStateAction<boolean>>,
    setShowClickPostConfirmationPopup: React.Dispatch<React.SetStateAction<boolean>>,
    setStore: React.Dispatch<React.SetStateAction<{ id: string, title: string }>>,
    updateFilters: (updateType: 'sortBy' | 'isArchive' | 'isActive' | 'serviceType' | 'title' | 'id', value?: 'true' | 'false' | 'created_at' | 'position' | 'pooja' | 'offerings' | 'promoter' | 'mandir_connect' | 'all' | string) => void,
    pagination: TablePaginationConfig,
    setPagination: React.Dispatch<React.SetStateAction<TablePaginationConfig>>,
): TableProps<CreateStore> => {
    const [dataSource, setDataSource] = useState(storeList)
    const [searchParams] = useSearchParams();
    const [title, setTitle] = useState<string>(searchParams?.get('title') || '');
    const [tooltipTitle, setTooltipTitle] = useState('Copy');
    const [tooltipVisible, setTooltipVisible] = useState(false)

    useEffect(() => { setDataSource(storeList) }, [storeList])

    const handleSearchTitleChange = useCallback((e: any) => {
        const currValue = e.target.value;
        setTitle(currValue);

        if (currValue) {
            const filteredData = storeList?.filter((entry) =>
                entry?.title?.toLowerCase().includes(currValue?.toLowerCase())
            );
            setDataSource(filteredData);
        } else {
            setDataSource(storeList);
            updateFilters('title', '');
        }
        //setPagination(1)
    }, [storeList, updateFilters]);


    const filterSearchTitleInput = useCallback(() => (
        <Tooltip
            title="Search works for current page"
            visible={tooltipVisible}
            placement="topLeft"
        >
            <Input
                placeholder="Search by Title"
                value={title}
                //onPressEnter={(e) => updateFilters('title', e.currentTarget.value)}
                onChange={handleSearchTitleChange}
                onFocus={() => {
                    setTooltipVisible(true);
                    setTimeout(() => setTooltipVisible(false), 3000); // Optional: auto-hide after 3s
                }}
                onBlur={() => setTooltipVisible(false)}
                allowClear
            />
        </Tooltip>
    ), [title, storeList, updateFilters]);


    const filterSearchIdInput = useCallback(() => (
        <Input
            placeholder="Search by Store ID"
            onPressEnter={(e) => {
                setPagination((prev) => ({ ...prev, current: 1 })); // reset to page 1 (offset 0)
                updateFilters('id', e.currentTarget.value);
            }}
            onChange={(e) => {
                if (e.target.value === '') {
                    setPagination((prev) => ({ ...prev, current: 1 }));
                    updateFilters('id', '');
                }
            }}
            allowClear
        />
    ), [updateFilters]);

    const triggerEdit = useCallback((record: any) => {
        setStore({
            id: record.id,
            title: record.title,
        })
        setShowPujaUpdateDrawer(true)
    }, [setShowPujaUpdateDrawer, setStore])

    const handleCopy = (id: string) => {
        navigator.clipboard.writeText(id);
        setTooltipTitle('Copied');
        setTimeout(() => setTooltipTitle('Copy'), 2000);
    };

    // const triggerCreateClickPost = useCallback((record: any) => {
    //     setStore({
    //         id: record.id,
    //         title: record.title,
    //     })
    //     setShowClickPostConfirmationPopup(true)
    // }, [setShowClickPostConfirmationPopup, setStore])

    const dataColumns = useMemo(() => [
        {
            title: <div style={{ display: 'flex', flexDirection: 'column' }}> <span>Title</span> <div>{filterSearchTitleInput()}</div></div>,
            dataIndex: 'title',
            key: 'no_of_items',
            width: '30%',
        },
        {
            title: <div style={{ display: 'flex', flexDirection: 'column' }}> <span>Store Id</span> <div>{filterSearchIdInput()}</div></div>,
            dataIndex: 'id',
            key: 'id',
            width: '20%',
            ellipsis: true,
            render: (id: string) => (
                <div>
                    <Tooltip title={tooltipTitle}>
                        <span style={{ cursor: 'pointer', marginRight: '8px', color: '#69b1ff' }} onClick={() => handleCopy(id)}>
                            <CopyOutlined />
                        </span>
                    </Tooltip>
                    <Tooltip placement="topLeft" title={id}>
                        {id}
                    </Tooltip>
                </div>
            ),
        },
        {
            title: '',
            key: 'action',
            width: '35%',
            render: (text: any, record: any, index: any) => {
                return (
                    <Row style={{ marginLeft: '100px' }} justify="space-evenly">
                        <Button type='primary' onClick={() => triggerEdit(record)}>
                            Puja updates
                        </Button>
                        <Button type='link'>
                            <Link to={`/monetisation/puja/hub/${record?.hub_id}/temple/${record?.id}/batch?name=${record?.title}&language_code=hi&alt_name=Hindi&country_code=IN`}>
                                Create Batch
                            </Link>
                        </Button>
                        {/* <Button onClick={() => triggerCreateClickPost(record)}>Clickpost create</Button> */}
                    </Row>
                )
            },
        },
    ], [filterSearchIdInput, filterSearchTitleInput, triggerEdit])

    return {
        pagination, dataSource: dataSource, columns: dataColumns, loading: {
            spinning: isLoading,
            indicator: <Spin indicator={<CustomLoader />} />,
        }, size: 'middle', sticky: true
    }
}

export default useTableConfig